export default __webpack_public_path__ + "static/media/undp.1e182445.png";